interface ReactIconProps {
    color?: string;
    className?: string;
}

function ReactionIcon({ color = 'currentColor', className }: ReactIconProps) {
    return (
        <svg
            width="9"
            height="9"
            viewBox="0 0 9 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M4.5 0C2.01436 0 0 2.01436 0 4.5C0 6.98564 2.01436 9 4.5 9C6.98564 9 9 6.98564 9 4.5C9 2.01436 6.98564 0 4.5 0ZM4.5 8.18182C2.47009 8.18182 0.818182 6.52991 0.818182 4.5C0.818182 2.47009 2.47009 0.818182 4.5 0.818182C6.52991 0.818182 8.18182 2.47009 8.18182 4.5C8.18182 6.52991 6.52991 8.18182 4.5 8.18182Z"
                fill={color}
            />
            <path
                d="M3.27274 4.24556C3.72461 4.24556 4.09092 3.87924 4.09092 3.42737C4.09092 2.9755 3.72461 2.60919 3.27274 2.60919C2.82087 2.60919 2.45456 2.9755 2.45456 3.42737C2.45456 3.87924 2.82087 4.24556 3.27274 4.24556Z"
                fill={color}
            />
            <path
                d="M5.72727 4.24556C6.17914 4.24556 6.54545 3.87924 6.54545 3.42737C6.54545 2.9755 6.17914 2.60919 5.72727 2.60919C5.2754 2.60919 4.90909 2.9755 4.90909 3.42737C4.90909 3.87924 5.2754 4.24556 5.72727 4.24556Z"
                fill={color}
            />
            <path
                d="M6.82446 4.84688C6.61091 4.77325 6.37773 4.88697 6.3041 5.10052C6.04473 5.85325 5.319 6.35888 4.49919 6.35888C3.67937 6.35888 2.95364 5.85325 2.69428 5.10052C2.62064 4.88697 2.38828 4.77325 2.17391 4.84688C1.96037 4.92052 1.84664 5.1537 1.92028 5.36725C2.29337 6.4497 3.32919 7.17706 4.49837 7.17706C5.66755 7.17706 6.70337 6.4497 7.07646 5.36725C7.1501 5.1537 7.03637 4.92052 6.82282 4.84688H6.82446Z"
                fill={color}
            />
        </svg>
    );
}

export default ReactionIcon;
